import { Fragment, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { CloseButton } from "react-bootstrap";
import { useWalletConnection } from "../../utility/useWalletConnection";
import { useData } from "../../utility/useData";
import { useDispatch } from "react-redux";
import { getInfo, getIsClaimed, getTickets } from "../../pages/Home/store";
import TicketItem from "./TicketItem";

const UserTickets = ({ onClose }) => {
  const { search } = useLocation();
  const dispatch = useDispatch();

  const {
    isConnected,
    connectedWalletInfo,
    address,
    chainId,
    signerVars,
    unSignerVars,
    mockVRF,
    errorMessage,
    clearError,
    open,
    connect,
    disConnect,
  } = useWalletConnection();

  const {
    decimals,
    initialResultMsg,
    initialData,
    initialGetInfo,
    reRender,
    poolData,
    showPoolDetail,
    setReRender,
    updatePoolData,
    togglePoolData,
    openData,
    closeData,
    statusText,
  } = useData();

  const [isLoading, setIsLoading] = useState(true);
  const [AWAITING_ASSIGN, setAWAITING_ASSIGN] = useState(null);
  const [AWAITING_DRAW, setAWAITING_DRAW] = useState(null);
  const [contractInfo, setContractInfo] = useState(initialGetInfo);
  const [tickets, setTickets] = useState([]);
  const [isClaimed, setIsClaimed] = useState(false);

  useEffect(() => {
    if (
      isConnected &&
      unSignerVars.contract &&
      poolData &&
      poolData.poolId > 0
    ) {
      async function initialize() {
        setIsLoading(true);
        const _AWAITING_ASSIGN = Number(
          await unSignerVars.contract.AWAITING_ASSIGN()
        );
        const _AWAITING_DRAW = Number(
          await unSignerVars.contract.AWAITING_DRAW()
        );
        setAWAITING_ASSIGN(_AWAITING_ASSIGN);
        setAWAITING_DRAW(_AWAITING_DRAW);

        const info = await dispatch(
          getInfo({ dispatch, unSignerVars, poolId: poolData.poolId, address })
        )
          .then((result) => {
            console.log("getInfo:", result.payload);
            if (result.payload.result) {
              setContractInfo(result.payload.result);
              return result.payload.result;
            }
          })
          .catch((error) => console.error(error));

        if (poolData.status > 4) {
          dispatch(
            getIsClaimed({
              dispatch,
              unSignerVars,
              poolId: poolData.poolId,
              address,
            })
          )
            .then((result) => {
              if (result.payload) {
                console.log(result.payload);
                setIsClaimed(result.payload.result);
              }
            })
            .catch((error) => console.error(error));
        }

        // const ticketsCache = JSON.parse(
        //   sessionStorage.getItem(`tickets-${address}-${poolData.poolId}`)
        // );

        // if (
        //   ticketsCache &&
        //   ticketsCache.length === Number(info.userTicketCount)
        // ) {
        //   console.log("ticketsCache:", ticketsCache);
        //   setTickets(ticketsCache);
        //   setIsLoading(false);
        // } else {
          dispatch(
            getTickets({
              dispatch,
              unSignerVars,
              poolId: poolData.poolId,
              address,
              userTicketCount: info.userTicketCount,
              decimals: poolData.prizeTokenDecimals,
            })
          )
            .then((result) => {
              console.log("getTickets:", result.payload);
              if (result.payload.result) {
                setTickets(result.payload.result);
                setIsLoading(false);
              }
            })
            .catch((error) => console.error(error));
        // }
      }
      initialize();
    }
  }, [isConnected, poolData, unSignerVars]);

  return (
    <div className={"loader"}>
      <div className={"prtitle"}>
        <CloseButton
          style={{ top: "1%", right: "1%", position: "absolute" }}
          onClick={() => onClose()}
        />
        <div className="font-second prize-title">
          My Tickets in {poolData.name} Pool
          <br />
          TICKET DETAILS
        </div>
        <div className="d-flex flex-column w-100 overflow-y-auto">
          {isLoading ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <span
                className="spinner-border"
                role="status"
                aria-hidden="true"
              ></span>
              <span className="sr-only">Loading</span>
            </div>
          ) : (
            <div className="ticket-area">
              {tickets.length > 0 &&
                tickets.map((ticket, index) => (
                  <Fragment key={index}>
                    {index % 9 < 5 && (
                      <TicketItem
                        AWAITING_ASSIGN={AWAITING_ASSIGN}
                        ticket={ticket}
                        AWAITING_DRAW={AWAITING_DRAW}
                        poolData={poolData}
                        contractInfo={contractInfo}
                        isClaimed={isClaimed}
                        index={index}
                      />
                    )}
                    {index % 9 > 4 && (
                      <TicketItem
                        AWAITING_ASSIGN={AWAITING_ASSIGN}
                        ticket={ticket}
                        AWAITING_DRAW={AWAITING_DRAW}
                        poolData={poolData}
                        contractInfo={contractInfo}
                        isClaimed={isClaimed}
                        index={index}
                      />
                    )}
                  </Fragment>
                ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserTickets;
